module.exports = __webpack_public_path__ + "resources/e8e1608aa346067a383ef9502626df07.png";